<template>
  <div
    v-if="list && list.length > 0"
    class="w-full grid md:grid-cols-5 grid-cols-2 md:gap-4 gap-2 box-border p-[10px] bobb rounded-[5px] bg-[#fff]"
  >
    <div
      v-for="(item, index) in list"
      :key="index"
      class="w-full flex items-center justify-center flex-col"
      @click="handelUrl(item)"
    >
      <img
        class="w-full max-h-[140px] h-full rounded-[5px] object-cover"
        v-lazy="item.logo"
        alt=""
      />
      <div class="o-h-e w-full text-[14px] text-[#333] min-h-[20px]">
        {{ item.title }}
      </div>
      <div class="text-[12px] text-[#999] w-full flex items-center justify-between">
        <span>{{ item.vod_time }}</span>
        <!-- <span>64011次播放</span> -->
        <span>{{ item.num }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  list: {
    type: Array,
    default: () => []
  }
})

const handelUrl = (item) => {
  window.open(item.href, '_blank')
}
</script>

<style scoped>
.bobb {
  border: 1px solid #eee;
}
</style>
